'use client'

import { useSearchParams } from 'react-router-dom'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import SendSms from './SendSms'
import MessageHistory from './MessageHistory'
import BulkSMSSend from './BulkSMSSend'

export default function Messaging() {
  const [searchParams, setSearchParams] = useSearchParams()
  const currentTab = searchParams.get('tab') || 'send'

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true })
  }

  return (
    <div className='grid gap-6 w-full max-w-3xl'>
      <Tabs
        value={currentTab}
        onValueChange={handleTabChange}
        className='space-y-4'
      >
        <TabsList className='flex'>
          <TabsTrigger value='send' className='flex-1'>
            Send
          </TabsTrigger>
          <TabsTrigger value='bulk-send' className='flex-1'>
            Send to a list
          </TabsTrigger>
          <TabsTrigger value='history' className='flex-1'>
            History
          </TabsTrigger>
        </TabsList>

        <TabsContent value='send' className='space-y-4'>
          <SendSms />
        </TabsContent>

        <TabsContent value='bulk-send' className='space-y-4'>
          <div className='grid gap-6 w-full'>
            <BulkSMSSend />
          </div>
        </TabsContent>

        <TabsContent value='history' className='space-y-4'>
          <MessageHistory />
        </TabsContent>
      </Tabs>
    </div>
  )
}